export default {
  state: {
    dashboardViewMode: {
      mode: 'table', // or 'list'
      show: false
    },
    connected: false,
    loading: false,
    error: null,
    language: 'pt_BR',
    snackbar: {
      show: false,
      text: '',
      timeout: 6000
    }
  },
  getters: {
    dashboardViewMode (state) {
      return state.dashboardViewMode
    },
    connected (state) {
      return state.connected
    },
    loading (state) {
      return state.loading
    },
    error (state) {
      return state.error
    },
    language (state) {
      return state.language
    },
    snackbar (state) {
      return state.snackbar
    }
  },
  // synchronuos
  mutations: {
    setDashboardViewMode (state, payload) {
      state.dashboardViewMode = payload
    },
    setConnection (state, paylod) {
      state.connected = paylod
    },
    setLoading (state, payload) {
      state.loading = payload
    },
    setError (state, payload) {
      state.error = payload
    },
    clearError (state) {
      state.error = null
    },
    setLanguage (state, payload) {
      state.language = payload
    },
    setSnackbar (state, payload) {
      state.snackbar = payload
    },
    closeSnackbar (state) {
      state.snackbar.show = false
    }
  },
  // asynchronous
  actions: {
    setDashboardViewMode ({ commit }, payload) {
      let _payload = {
        mode: 'table',
        show: true
      }

      if ('mode' in payload) {
        if (payload.mode === 'table' || payload.mode === 'list') {
          _payload.mode = payload.mode
        }
      }

      if ('show' in payload) {
        _payload.show = payload.show
      }
      commit('setDashboardViewMode', _payload)
    },
    setConnection ({ commit }, payload) {
      commit('setConnection', payload)
    },
    clearError ({ commit }) {
      commit('clearError')
    },
    setLanguage ({ commit }, payload) {
      commit('setLanguage', payload)
    },
    setSnackbar ({ commit }, payload) {
      let _payload = {
        show: true,
        text: '',
        timeout: 6000
      }
      if ('show' in payload) {
        _payload.show = payload.show
      }
      if ('text' in payload) {
        _payload.text = payload.text
      }
      if ('timeout' in payload) {
        _payload.timeout = payload.timeout
      }
      commit('setSnackbar', _payload)
    },
    closeSnackbar ({ commit }) {
      commit('closeSnackbar')
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/shared/index.js